import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Link } from "react-router-dom";
import DesignationEmp from "./DesignationEmp";
import Select from "react-select";
import Swal from "sweetalert2";
import { useLoader } from "../../Loader";
import MultiFileUpload from "./MultiFileUpload";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    announcementContent: "",
    expireDateTime: "",
    status: "",
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [editId, setEditId] = useState();
  const [selectedDesignation, setselectedDesignation] = useState(null);
  const [role, setRole] = useState([]);
  const [empListByRole, setEmpListByRole] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [dateError, setDateError] = useState(false);

  const { startLoader, stopLoader } = useLoader();
  const [EditfileUploads, setEditFileUploads] = useState([]);
  useEffect(() => {
    getRoleList();
  }, []);

  const getRoleList = () => {
    startLoader();
    utils
      .callAPI("get", `/role/list?page=${0}&per_page=${0}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeItems = res.result.filter(
            (item) => item.isActive === "1"
          );
          console.log(activeItems);
          setRole(activeItems);
          stopLoader();
        } else {
          stopLoader();
          setRole([]);
        }
      })
      .catch((err) => {
        stopLoader();
        setRole([]);
      });
  };

  const options = [
    {
      value: 0,
      label: "All Designation",
    },
    ...(role?.map((prod) => ({
      value: prod?.id,
      label: prod?.roleName,
    })) || []),
  ];

  const handleDesignation = (selectedOptions) => {
    const allDesignationSelected = selectedDesignation?.some(
      (option) => option.value === "0"
    );

    if (allDesignationSelected && selectedOptions.length > 1) {
      Swal.fire({
        title: "Alert!",
        text: 'To select other designations,  please remove  "All Designation".',
        icon: "warning",
        confirmButtonText: "Close",
      });

      return;
    }

    const newAllDesignationSelected = selectedOptions.some(
      (option) => option.value === 0
    );

    if (newAllDesignationSelected) {
      setselectedDesignation([{ value: "0", label: "All Designation" }]);
      setEmpListByRole([]);
    } else {
      setselectedDesignation(selectedOptions);

      const removedDesignations = empListByRole.filter(
        (role) => !selectedOptions?.some((option) => option.value === role.key)
      );

      setEmpListByRole((prevList) =>
        prevList.filter(
          (role) => !removedDesignations.some((r) => r.key === role.key)
        )
      );

      if (selectedOptions && selectedOptions.length > empListByRole.length) {
        const latestSelectedRole = selectedOptions[selectedOptions.length - 1];
        getEmpByDesignation(latestSelectedRole.value);
      }
    }
  };

  const getEmpByDesignation = (roleId) => {
    startLoader();
    utils
      .callAPI("get", `Announcement/emp-by-role?roleId=${roleId}`)
      .then((res) => {
        if (res) {
          const transformedData = {
            key: res.roleId.toString(),
            label: res.name,
            children: res.emp.map((employee) => ({
              key: employee.userId.toString(),
              label: employee.emp_name,
            })),
          };

          setEmpListByRole((prevList) => {
            const existingKeys = prevList.map((item) => item.key);
            if (!existingKeys.includes(transformedData.key)) {
              return [...prevList, transformedData];
            }
            return prevList;
          });
        }
        stopLoader();
      })
      .catch((err) => {
        console.error(err);
        stopLoader();
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const isDateValid = !!formData.expireDateTime;

    if (form.checkValidity() === false || !isDateValid) {
      e.stopPropagation();
      setValidated(true);
      if (!isDateValid) setDateError(true);
      return;
    }

    setDateError(false); // clear date error
    setIsSubmit(true);
    startLoader();
  };

  const base64Files = [];
  // useEffect( () => {
  //   if (isSubmit) {
  //     const selectedPermissionIds = Object.keys(selectedKeys)
  //       .filter(
  //         (key) =>
  //           !isNaN(parseInt(key, 10)) &&
  //           selectedKeys[key]?.checked &&
  //           !empListByRole.some((role) => role.key === key)
  //       )
  //       .map((key) => parseInt(key, 10));

  //     const designationIds = selectedDesignation.map((item) =>
  //       parseInt(item.value, 10)
  //     );

  //     var bodyFormData = new FormData();
  //     if (isEdit) {
  //       bodyFormData.append("id", editId);
  //     }
  //     bodyFormData.append("title", formData.title);
  //     bodyFormData.append("description", formData.announcementContent);
  //     bodyFormData.append(
  //       "expiry_date",
  //       moment(formData.expireDateTime).format("YYYY-MM-DD")
  //     );
  //     bodyFormData.append("isActive", formData.status);
  //     bodyFormData.append("designationId", designationIds);
  //     bodyFormData.append("userId", selectedPermissionIds);

  //     const base64Files = [];
  //     const readFileAsBase64 = (file) => {
  //       return new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //           try {
  //             const fileType = getFileMimeType(file); // Ensure this function is defined
  //             const base64FileData = `${fileType}${reader.result.split(",")[1]}`;
  //             resolve(base64FileData);
  //           } catch (error) {
  //             reject(error);
  //           }
  //         };
  //         reader.onerror = (error) => reject(error);
  //         reader.readAsDataURL(file);
  //       });
  //     };

  //     const processFiles = async () => {
  //       try {
  //         for (const file of uploadedFiles) {
  //           const base64File = await readFileAsBase64(file);
  //           base64Files.push(base64File);
  //         }

  //       } catch (error) {
  //         console.error("Error processing files:", error);
  //       }
  //     };

  //     if (uploadedFiles.length > 0) {
  //       processFiles();
  //     }

  //     console.log("base64Files", base64Files);
  //         bodyFormData.append("announce_files", JSON.stringify(base64Files));
  //     // console.log("base64Files");
  //     //     console.log(base64Files);
  //     // bodyFormData.append("announce_files", JSON.stringify(base64Files));
  //     utils
  //       .callAPI("post", `/Announcement/add`, bodyFormData)
  //       .then((res) => {
  //         if (typeof res !== "undefined") {
  //           setIsSubmit(false);
  //           setEditId("");
  //           setFormData({
  //             announcementContent: "",
  //             expireDateTime: "",
  //             status: "",
  //             title: "",
  //           });
  //           const propdata = {
  //             mode: "list",
  //           };
  //           props.onChange(propdata);
  //           stopLoader();
  //         } else {
  //           stopLoader();
  //           setIsSubmit(false);
  //         }
  //       })
  //       .catch((err) => {
  //         stopLoader();
  //         setIsSubmit(false);
  //       });
  //     stopLoader();
  //     setIsSubmit(false);
  //   }
  // }, [isSubmit]);
  // const processFiles = async () => {
  //   const base64Files = [];
  //   uploadedFiles.forEach(async (file) => {
  //     const base64FileData = await readFileAsBase64(file);
  //     //console.log(file);
  //     // const reader = new FileReader();
  //     // reader.onloadend = () => {

  //     //   const fileType = getFileMimeType(file);
  //     //   const base64FileData = `${fileType}${reader.result.split(",")[1]}`;

  //       base64Files.push(base64FileData);
  //       // filesProcessed += 1;
  //       // if (filesProcessed === uploadedFiles.length) {

  //       // }
  //     //};

  //     //reader.readAsDataURL(file);
  //   });
  //   //return base64Files;
  // }
  // const readFileAsBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       try {
  //         const fileType = getFileMimeType(file); // Ensure this function is defined
  //         const base64FileData = `${fileType}${reader.result.split(",")[1]}`;
  //         console.log(base64FileData);
  //         console.log(base64FileData);
  //         resolve(base64FileData);
  //       } catch (error) {
  //         console.log("in reject");
  //         console.log(error);
  //         reject(error);
  //       }
  //     };
  //     reader.onerror = (error) => reject(error);
  //     reader.readAsDataURL(file);
  //   });
  // };

  useEffect(() => {
    if (isSubmit) {
      const selectedPermissionIds = Object.keys(selectedKeys)
        .filter(
          (key) =>
            !isNaN(parseInt(key, 10)) &&
            selectedKeys[key]?.checked &&
            !empListByRole.some((role) => role.key === key)
        )
        .map((key) => parseInt(key, 10));

      const designationIds = selectedDesignation.map((item) =>
        parseInt(item.value, 10)
      );

      const bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", editId);
      }
      bodyFormData.append("title", formData.title);
      bodyFormData.append("description", formData.announcementContent);
      bodyFormData.append(
        "expiry_date",
        moment(formData.expireDateTime).format("YYYY-MM-DD")
      );
      bodyFormData.append("isActive", formData.status);
      bodyFormData.append("designationId", designationIds);
      bodyFormData.append("userId", selectedPermissionIds);

      const processFiles = async () => {
        const readFileAsBase64 = (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              try {
                const fileType = getFileMimeType(file); // Replace with your function
                const base64FileData = {
                  file: `${fileType},${reader.result.split(",")[1]}`,
                };
                resolve(base64FileData);
              } catch (error) {
                reject(error);
              }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          });
        };

        // Process all uploaded files
        return await Promise.all(
          uploadedFiles.map((file) => readFileAsBase64(file))
        );
      };

      const submitForm = async () => {
        try {
          const base64Files = await processFiles(); // Process files asynchronously
          console.log("base64Files", base64Files);

          bodyFormData.append("announce_files", JSON.stringify(base64Files));

          const res = await utils.callAPI(
            "post",
            `/Announcement/add`,
            bodyFormData
          );
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setEditId("");
            setFormData({
              announcementContent: "",
              expireDateTime: "",
              status: "",
              title: "",
            });
            props.onChange({ mode: "list" });
          }
        } catch (err) {
          console.error("Error during submission:", err);
        } finally {
          stopLoader();
          setIsSubmit(false);
        }
      };

      submitForm();
    }
  }, [isSubmit]);

  const getFileMimeType = (file) => {
    const fileExtension = file.name.split(".").pop().toLowerCase();
    switch (fileExtension) {
      case "xls":
        return "data:application/xls;base64,";
      case "doc":
      case "docx":
        return "data:application/msword;base64,";
      case "png":
        return "data:image/png;base64,";
      case "jpg":
      case "jpeg":
        return "data:image/jpeg;base64,";
      case "pdf":
        return "data:application/pdf;base64,";
      default:
        return "data:application/octet-stream;base64,";
    }
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      startLoader();
      setEditId(props.rowData.id);
      setisEdit(true);
      setFormData({
        announcementContent: props.rowData.description,
        status: props.rowData.isActive,
        expireDateTime: props.rowData.expiry_date,
        title: props.rowData.title,
      });

      const designationIds = props.rowData.designationId
        ? props.rowData.designationId.split(",")
        : [];

      const userIds = props.rowData.userId
        ? props.rowData.userId.split(",")
        : [];

      const selectedDesignations = designationIds.map((id) => {
        const roleName = role?.find((r) => r.id.toString() === id)?.roleName;
        return {
          value: id,
          label: roleName ?? "All Designation",
        };
      });
      setselectedDesignation(selectedDesignations);

      const selectedKeys = {};
      userIds.forEach((id) => {
        selectedKeys[id] = { checked: true, partialChecked: false };
      });

      setSelectedKeys(selectedKeys);

      designationIds.forEach((id) => {
        getEmpByDesignation(id);
      });

      setEditFileUploads(props.rowData.document);
      stopLoader();
    } else {
      setisEdit(false);
      stopLoader();
    }
  }, [props.rowData, role]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"}</h4>

          <div className="card-header-action">
            <Link className="btn btn-underline" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            {/* <RB.Row>
              <DesignationEmp
                selectedDesignation={selectedDesignation}
                setselectedDesignation={setselectedDesignation}
              />
            </RB.Row> */}
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="productName"
                    className="floating-label-fancy"
                    label="Select Designation"
                  >
                    <Select
                      options={options}
                      value={selectedDesignation}
                      onChange={handleDesignation}
                      placeholder="Select Designation"
                      className="bom-productName-select"
                      classNamePrefix="select"
                      isClearable
                      required
                      isMulti
                    />
                  </RB.FloatingLabel>
                </div>

                <div className="mb-1">
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="formTitle"
                      label="Title"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Title"
                        name="title"
                        value={formData.title}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </div>

                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formAnnouncementContent"
                    label="Description"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Description"
                      name="announcementContent"
                      value={formData.announcementContent}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>

                <div className="mb-3 mt-4">
                  <DatePicker
                    selected={formData.expireDateTime}
                    onChange={(date) => {
                      setFormData({ ...formData, expireDateTime: date });
                      setDateError(false); // clear error on selection
                    }}
                    dateFormat="dd-MM-yyyy"
                    className={`form-control ${dateError ? "is-invalid" : ""}`}
                    placeholderText="Select expire date"
                    minDate={new Date()}
                    required
                  />
                  {dateError && (
                    <div className="invalid-feedback d-block">
                      Please select an expire date.
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formStatus"
                    label="Status"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Status...</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <DesignationEmp
                  empListByRole={empListByRole}
                  selectedKeys={selectedKeys}
                  setSelectedKeys={setSelectedKeys}
                />
              </RB.Col>
              <RB.Col md={12}>
                <MultiFileUpload
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  EditfileUploads={EditfileUploads}
                  setEditFileUploads={setEditFileUploads}
                />
              </RB.Col>
              <RB.Row className="align-items-center mt-3 justify-content-end">
                <RB.Col xs="auto">
                  <RB.Button variant="primary" type="submit">
                    Submit
                  </RB.Button>
                </RB.Col>
              </RB.Row>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
